// bind_Modal
import bind_modal from '@/components/AreaBind';

// card_detail
import card_detail from '@/components/CardDetail';

// record_Modal
import record_modal from '@/components/RecordModal';

//invite_modal
import invite_apply from '@/components/InviteApply';

// comfirm_modal
import comfirm_modal from '@/components/ComfirmModal';

// toast
import toast from '@/components/Toast';

let utils = {
    $bind_modal : bind_modal,
    $card_detail : card_detail,
    $record_modal : record_modal,
    $invite_apply : invite_apply,
    $comfirm_modal : comfirm_modal,
    $toast : toast,
}

export default utils;